import { classNames } from 'lib/ClassNames';

export const PrimaryActionButton = ({
  label,
  disabled = false,
  fullWidth = false,
  onClick,
  className,
}) => {
  const baseStyle =
    'font-sans inline-flex items-center justify-center gap-1 rounded-3xl px-5 py-2 text-xs font-semibold transition-all duration-300';

  const disabledStyle = 'bg-gray-200 text-gray-500 cursor-not-allowed';

  const activeStyle = 'bg-primary-main text-white hover:bg-primary-dark cursor-pointer';

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={(e) => {
        if (!disabled && onClick) onClick(e);
      }}
      className={classNames(
        baseStyle,
        disabled ? disabledStyle : activeStyle,
        fullWidth && 'w-full',
        className,
      )}>
      {label}
    </button>
  );
};
